"use client";

import {useEffect} from "react";
import {toast} from "react-toastify";
import {AxiosError} from "axios";

interface ErrorHandlerProps {
    error: AxiosError | null;
    messageKey?: string | string[];
}

interface ErrorObject {
    [key: string]: string | string[] | undefined;
}

const ErrorHandler = ({error}: ErrorHandlerProps) => {
    const errorsKeyList = ["detail", "non_field_errors", "message"];

    useEffect(() => {
        if (error) {
            if (error.response && error.response.data) {
                const errorObject = error.response.data;

                if (isErrorObject(errorObject)) {
                    const errorObjectKeys = Object.keys(errorObject);

                    if (errorObjectKeys.length > 0) {
                        const errorKey = errorObjectKeys[0];
                        const errorValue = errorObject[errorKey];

                        let message = "";

                        if (Array.isArray(errorValue)) {
                            message = errorValue.join("<br />");
                        } else if (typeof errorValue === "string") {
                            message = errorValue;
                        } else {
                            message = "خطای ناشناخته";
                        }

                        // نمایش کلید فقط اگر خارج از لیست پیش‌فرض باشه
                        // if (!errorsKeyList.includes(errorKey)) {
                        //     message = `<strong>${errorKey}:</strong><br />${message}`;
                        //     toast.error(<span dangerouslySetInnerHTML={{__html: message}}/>);
                        // } else {
                            toast.error(<span dangerouslySetInnerHTML={{__html: message}}/>);
                        // }
                    }
                }
            } else if (error.request) {
                toast.error("پاسخی از سرور دریافت نشد!");
            } else {
                toast.error("خطای ناشناخته!");
            }
        }
    }, [error]);

    return null;
};

// Type guard
function isErrorObject(data: unknown): data is ErrorObject {
    return typeof data === "object" && data !== null;
}

export default ErrorHandler;
